import { render, staticRenderFns } from "./TaskStatusIcon.vue?vue&type=template&id=c43d6d7e"
import script from "./TaskStatusIcon.vue?vue&type=script&lang=js"
export * from "./TaskStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports